/**
 * Whole-screen loading / message states, in `cp-*` tokens.
 *
 * New to the SPA. Next.js covered these with `loading.tsx` and a server
 * redirect that the user never saw; a client-routed app has to draw the gap
 * between "session restoring" and "page ready" itself.
 */
import { Loader2 } from "lucide-react";

export function FullPageSpinner({ label }: { label?: string }) {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-3 bg-[var(--cp-canvas)]"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-6 w-6 animate-spin text-[var(--cp-accent)]" aria-hidden="true" />
      {label && <p className="text-sm text-[var(--cp-ink-3)]">{label}</p>}
    </div>
  );
}

export function FullPageMessage({
  title,
  body,
  actionLabel,
  onAction,
}: {
  title: string;
  body?: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--cp-canvas)] p-4">
      <div className="cp-card w-full max-w-md space-y-3 p-6 text-center">
        <h1 className="text-lg font-semibold text-[var(--cp-ink)]">{title}</h1>
        {body && <p className="text-sm text-[var(--cp-ink-2)]">{body}</p>}
        {actionLabel && onAction && (
          <button type="button" onClick={onAction} className="cp-btn cp-btn--soft mx-auto">
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
}
